import Header from "../../components/Header/Header";
import { Container} from "./styles";
import Lottie from "react-lottie";
import animationData from "../../assets/lotties/success.json";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

function Success() {
  const history = useHistory();
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    setTimeout(() => {
      history.push("/lojasedmil.com.br");
    }, 4000);
  },);

  return (
    <>
      <Header />
      <Container>
        <div >
          <Lottie options={defaultOptions} height={300} width={300} />
        </div>
        <div>
          <strong>Sucesso!</strong>
          <p>Você será redirecionado para uma nova guia!</p>
        </div>
      </Container>
    </>
  );
}

export default Success;
